<template>
  
    <!-- inputs -->
    <div class="row center ch">      
        <input class="roundInput margin" @input="refresh" inputmode="numeric" v-model.number="query.eq.id"  type="number" placeholder="ID" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">
        <input class="roundInput margin" @input="refresh" title="Email..."  v-model="query.like.email" type="email" placeholder="Email" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">                
        <input class="roundInput margin" @input="refresh" title="Username..."  v-model="query.like.username" type="email" placeholder="Username" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">                
    </div>
    
    <br>

    <table v-if="users && users.length">
        <tr class="bold">
          
          <td>ID</td>
          <!-- <td title="Country">C</td> -->
          <!-- <td title="Provider" class="cc">P</td> -->
          <td title="Active" class="cc">A</td>
          <td title="Verified" class="cc">V</td>          
          <!-- <td title="KYC" class="cc">K</td>           -->
          
          <td>Name</td>
          <td>Email</td>
          <!-- <td>Location</td> -->
          <td>Username</td>          
          <!-- <td>Name</td> -->
          <!-- <td>Geoid</td> -->
          <!-- <td>Country</td> -->
          <!-- <td>City</td> -->
          <!-- <td class="cc t4" title="Favorite">★</td> -->
          <!-- <td class="tt">Date</td> -->
          
        </tr>
        <tr class="hover" v-for="(item, index) in users" :key="index" @click="$emit('update', item)">
          
          <td class="cc" >{{ item.id }}</td>
          <!-- <td class="cc" :title="item.country"><img style="width: 16px; height: 16px;" :src="`/images/icons/flags/round/${item.country || 'us'}.svg`" ></td> -->
          <!-- <td class="cc" :title="item.provider"><img style="width: 16px; height: 16px;" :src="`/images/icons/providers/${!item.provider ? 'apple': item.provider == 1 ? 'google' : 'email'}.svg`" ></td> -->
          
          <!-- <td class="cc" @click="current = item">{{ tools.ago(item.updated)  }}</td> -->
          <!-- <td class="cc"> <switcher small :checked="item.active"  @switch="item.active = !item.active; updateUser(item.id, 'active', item.active)"></switcher></td> -->
          <!-- <td class="cc"> <switcher small :checked="item.verified"  @switch="item.verified = !item.verified; updateUser(item.id, 'verified', item.verified)" ></switcher></td> -->
          <td class="fit" title="Active"><div v-if="item.active"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7503 9.16665H9.83366L12.5003 2.08331H7.91699L5.41699 10.8333H9.00033L7.08366 18.75L13.7503 9.16665Z" fill="#FFC107"/></svg></div></td>
          <td class="fit" title="Verified"><div v-if="item.verified"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.25L11.9583 2.75L14.375 2.41667L15.2917 4.70833L17.5833 5.625L17.25 8.04167L18.75 10L17.25 11.9583L17.5833 14.375L15.2917 15.2917L14.375 17.5833L11.9583 17.25L10 18.75L8.04167 17.25L5.625 17.5833L4.70833 15.2917L2.41667 14.375L2.75 11.9583L1.25 10L2.75 8.04167L2.41667 5.625L4.70833 4.70833L5.625 2.41667L8.04167 2.75L10 1.25Z" fill="#1881FD"/><path d="M14.4167 6.08331L8.75 11.75L6.41667 9.41665L5.25 10.5833L8.75 14.0833L15.5833 7.24998L14.4167 6.08331Z" fill="#CCFF90"/></svg></div></td>
          <!-- <td class="fit" title="KYC"><div v-if="item.kyc"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.99967 1.66669C4.55765 1.66669 4.13372 1.84228 3.82116 2.15484C3.5086 2.4674 3.33301 2.89133 3.33301 3.33335V16.6667C3.33301 17.1087 3.5086 17.5326 3.82116 17.8452C4.13372 18.1578 4.55765 18.3334 4.99967 18.3334H14.9997C15.4417 18.3334 15.8656 18.1578 16.1782 17.8452C16.4907 17.5326 16.6663 17.1087 16.6663 16.6667V3.33335C16.6663 2.89133 16.4907 2.4674 16.1782 2.15484C15.8656 1.84228 15.4417 1.66669 14.9997 1.66669H4.99967ZM9.99967 4.16669C11.1047 4.16669 12.1646 4.60567 12.946 5.38707C13.7274 6.16848 14.1663 7.22828 14.1663 8.33335C14.1663 9.43842 13.7274 10.4982 12.946 11.2796C12.1646 12.061 11.1047 12.5 9.99967 12.5C8.89461 12.5 7.8348 12.061 7.0534 11.2796C6.27199 10.4982 5.83301 9.43842 5.83301 8.33335C5.83301 7.22828 6.27199 6.16848 7.0534 5.38707C7.8348 4.60567 8.89461 4.16669 9.99967 4.16669ZM9.99967 5.00002C9.65801 5.51669 9.37467 6.07502 9.19967 6.66669H10.7997C10.6203 6.07328 10.3505 5.51111 9.99967 5.00002ZM8.91634 5.18335C8.14967 5.44169 7.49967 5.97502 7.11634 6.66669H8.33301C8.48301 6.15002 8.66634 5.65002 8.91634 5.18335ZM11.0747 5.18335C11.3247 5.65002 11.5163 6.15002 11.6663 6.66669H12.883C12.4997 5.97502 11.8413 5.45002 11.0747 5.18335ZM6.77467 7.50002C6.70801 7.76669 6.66634 8.04169 6.66634 8.33335C6.66634 8.62502 6.70801 8.90002 6.77467 9.16669H8.18301C8.14967 8.89169 8.12467 8.61669 8.12467 8.33335C8.12467 8.05002 8.14967 7.77502 8.18301 7.50002H6.77467ZM9.02467 7.50002C8.98301 7.76669 8.95801 8.05002 8.95801 8.33335C8.95801 8.61669 8.98301 8.89169 9.02467 9.16669H10.9747C11.008 8.89169 11.0413 8.61669 11.0413 8.33335C11.0413 8.05002 11.008 7.76669 10.9747 7.50002H9.02467ZM11.8163 7.50002C11.8497 7.77502 11.8747 8.05002 11.8747 8.33335C11.8747 8.61669 11.8497 8.89169 11.8163 9.16669H13.2247C13.2913 8.90002 13.333 8.62502 13.333 8.33335C13.333 8.04169 13.2913 7.76669 13.2247 7.50002H11.8163ZM7.11634 10C7.49967 10.6917 8.14967 11.2167 8.91634 11.4834C8.66634 11.0167 8.48301 10.525 8.33301 10H7.11634ZM9.19967 10C9.37467 10.6 9.65801 11.15 9.99967 11.6667C10.3497 11.15 10.6247 10.6 10.7997 10H9.19967ZM11.6663 10C11.5163 10.525 11.3247 11.0167 11.0747 11.4834C11.8413 11.2167 12.4997 10.6917 12.883 10H11.6663ZM5.83301 14.1667H14.1663V15.8334H5.83301V14.1667Z" fill="#4CAF50"/></svg></div></td> -->
          
          <!-- <switcher small :checked="item.kyc" @switch="item.kyc = !item.kyc; updateUser(item.id, 'kyc', item.kyc)" ></switcher> -->
          
          <td class="tt" >{{ item.name || 'No name' }}</td>
          <td class="tt" >{{ item.email }}</td>
          <!-- <td><City v-if="item.country" :country="item.country" :city="item.city" :state="item.state" /></td> -->
          <td class="tt" >{{ item.username.startsWith('#') ? '' : item.username }}</td>
          
          
          <!-- <td class="cc" >{{ tools.ago(item.created)  }}</td>           -->
        </tr>
      </table>

    <!-- <div class="column wrap center" v-if="users.length">
      
      <p class="tag ch" :title="`ID: ${item.id} • Email: ${item.email} • Country: ${item.country}`" v-for="(item, index) in users" :key="index" @click="$emit('update', item)">{{ item.name || item.email }}</p>
    </div> -->

    <br>

    

</template>
<script>
import { defineComponent } from 'vue';
export default defineComponent({
  mounted() {      
    this.refresh()    
  },
  data() {
    return {    
      id: undefined,  
      items:[], 
      locations:[],

      query:{              
        limit: 20,
        offset: 0,
        sort: 'id',
        desc: true,
        eq:{},
        gt:{},
        lt:{},
        like:{},
        
      },

           
    }
  },
  computed: {
    users(){      
      return this.items
    },   
    
    
  },
  
  methods: {


    reset(){
      this.query = {
        emails: true,        
        limit: 30,
        offset: 0,
        sort: 'id',
        desc: true,                
        eq:{},
        gt:{},
        lt:{},
        like:{},        
      }
      this.refresh()
    },
    
   
    async refresh(){
      let res = await this.api.send('admin/accounts/search', this.query)
      console.log(res)
      if (res.error){
        console.log(res.error)        
        return
      }
      this.items = res.resp
      // this.items.push(...this.items)
      // this.items.push(...this.items)
      // this.items.push(...this.items)
      // this.items.push(...this.items)
      // this.items.push(...this.items)
    },
    
    
  },
});

</script>
<style scoped>
body{
  overflow-y: scroll ;
}
.subtitle {
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  text-align: center;
  letter-spacing: 0.0em;
  color: var(--g4);
  margin: 10px 0;
  /* margin-left: -5px; */

}

.tabs {
  margin: 0 10px;
}

.tableimage{
  width: 20px;
  height: 20px;
  background: none;
  border: 1px solid var(--g2);
  border-radius: 100px;
}

.jsonpre{
  font-family: monospace;
  font-size: 11px;
  line-height: 15px;
}



</style>